export default __webpack_public_path__ + "static/media/Location-gray.6ff5300a.svg";